import { render, staticRenderFns } from "./CreateBankStatement.vue?vue&type=template&id=0ccf970a"
import script from "./CreateBankStatement.vue?vue&type=script&lang=js"
export * from "./CreateBankStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports